// Base URL for API requests. Empty string in production (same-origin); set
// REACT_APP_API_URL for local dev against a separately-hosted API.
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';
